import { useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";
import { useLanguage } from "@/i18n";

export const CookieBanner = () => {
    const { t } = useLanguage();
    const [visible, setVisible] = useState(() => !localStorage.getItem("midora-cookie-consent"));

    const choose = (value) => {
        localStorage.setItem("midora-cookie-consent", value);
        if (value === "accepted" && window.__enableAnalytics) window.__enableAnalytics();
        setVisible(false);
    };

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    initial={{ y: 120, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 120, opacity: 0 }}
                    transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                    data-testid="cookie-banner"
                    className="fixed inset-x-0 bottom-0 z-[70] border-t border-white/10 bg-[#151921]/95 backdrop-blur-xl"
                >
                    <div className="mx-auto flex max-w-[1600px] flex-col gap-5 px-5 py-6 md:flex-row md:items-center md:justify-between md:px-12 lg:px-24">
                        <div className="flex items-start gap-4">
                            <Cookie className="mt-0.5 h-5 w-5 shrink-0 text-midora-red" />
                            <p className="max-w-2xl text-xs leading-relaxed text-white/60 md:text-sm">
                                {t("cookie.text")}{" "}
                                <Link to="/privacy" data-testid="cookie-policy-link" className="text-midora-red underline underline-offset-2 transition-colors duration-300 hover:text-white">
                                    {t("cookie.policy")}
                                </Link>
                            </p>
                        </div>
                        <div className="flex shrink-0 gap-3">
                            <button
                                data-testid="cookie-reject-btn"
                                onClick={() => choose("rejected")}
                                className="border border-white/20 px-6 py-3 font-mono text-[10px] uppercase tracking-[0.2em] text-white/70 transition-colors duration-300 hover:border-white/50 hover:text-white"
                            >
                                {t("cookie.reject")}
                            </button>
                            <button
                                data-testid="cookie-accept-btn"
                                onClick={() => choose("accepted")}
                                className="bg-[#DBD1BD] px-6 py-3 font-mono text-[10px] uppercase tracking-[0.2em] text-[#1C2029] transition-colors duration-300 hover:bg-midora-red hover:text-white"
                            >
                                {t("cookie.accept")}
                            </button>
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
